<template>
  <div>
    <div
      v-if="isLoading"
      class="alert alert-info"
      role="status">Loading...</div>
    <div
      v-if="error"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true" /> {{ error }}
    </div>

    <EXCMCaseProblemForm
      :handle-submit="onSendForm"
      :handle-update-field="updateField"
      :values="item"
      :id-case="idCase"
      :errors="violations" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import EXCMCaseProblemForm from './Form'

const { mapGetters, mapActions } = createNamespacedHelpers('excmcaseproblem/create')

export default {
  props: {
    idCase: {
      type: String,
      required: true
    }
  },

  components: {
    EXCMCaseProblemForm
  },

  data () {
    return {
      item: {}
    }
  },

  computed: mapGetters([
    'error',
    'isLoading',
    'created',
    'violations'
  ]),

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (!created) {
        return
      }
      this.$emit('reload')
      this.$bvModal.hide('addCaseProblemToCaseModal')
    }
  },

  methods: {
    ...mapActions([
      'create'
    ]),

    onSendForm () {
      this.create(this.item)
    },

    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
